import { customerDashboardApi } from "../../api";

const CustomerDashboardService = {
  /**
   * Obtiene las estadísticas del dashboard de clientes.
   * GET /api/dashboard/customers/stats
   */
  getStats: async () => {
    try {
      const response = await customerDashboardApi.fetchCustom("/stats");
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default CustomerDashboardService;
